import React, { Component } from 'react'
import classnames from 'classnames'

export default class InputGroup extends Component {

    static Addon = ({
        position,
        containerClassName,
        textClassName,
        children,
        onClick,
    }) => (
        <div
            className={classnames({
                [`input-group-${position}`]: true,
                [containerClassName]: containerClassName,
            })}
            onClick={onClick}
        >
            <span
                className={classnames({
                    'input-group-text': true,
                    [textClassName]: textClassName,
                })}
            >
                {children}
            </span>
        </div>
    )

    static Input = ({
        className,
        inputRef,
        ...rest
    }) => (
        <input
            className={classnames({
                'form-control': true,
                [className]: className,
            })}
            ref={inputRef}
            {...rest}
        />
    )

    render() {
        const {
            className,
            children,
        } = this.props

        return (
            <div
                className={classnames({
                    'input-group': true,
                    [className]: className,
                })}
            >
                {children}
            </div>
        )
    }
}
